import { Input } from "antd";
import styled from "styled-components";

export const TableTextFilterWrapper = styled.div``;

export const TableTextFilterInputWrapper = styled.div`
  padding: 0.5rem;
`;

export const TableTextFilterInput = styled(Input)`
  display: block;
`;

export const TableTextFilterActions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 7px 8px;
  overflow: hidden;
  background-color: inherit;
  border-top: 1px solid rgba(5, 5, 5, 0.06);
`;
